import { useState, useEffect } from "react";
import { TableCell } from "./TableCell";

export function ArrayPreviewCell({ value }) {
  const [ownValue, setOwnValue] = useState(value?.join("; ") ?? "");

  useEffect(() => {}, [ownValue]);
  return (
    <TableCell style={{ width: 120 }}>
      <div>[{ownValue?.length === 0 ? "---" : ownValue}]</div>
    </TableCell>
  );
}
